import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_1_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_1_line: fromDatatype.GuidDataFieldInterface;
  date_doc_1_hdr: fromDatatype.TimestampTzDatatypeInterface;
  date_doc_1_line: fromDatatype.TimestampTzDatatypeInterface;
  guid_doc_2_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_2_line: fromDatatype.GuidDataFieldInterface;
  date_doc_2_hdr: fromDatatype.TimestampTzDatatypeInterface;
  date_doc_2_line: fromDatatype.TimestampTzDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  option: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  quantity_contra: fromDatatype.NumericDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  amount_contra: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  guid_doc_event: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  server_doc_type_doc_1_hdr: fromDatatype.VarcharDatatypeInterface;
  server_doc_type_doc_2_hdr: fromDatatype.VarcharDatatypeInterface;
  server_doc_type_doc_1_line: fromDatatype.VarcharDatatypeInterface;
  server_doc_type_doc_2_line: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_1: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_2: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_3: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_4: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_5: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_1: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_2: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_3: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_4: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_5: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_reference_no: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_tracking_no: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_1: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_2: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_3: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_4: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_5: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_1: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_2: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_3: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_4: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_5: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_reference_no: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_tracking_no: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_generic_doc_link_RowClass
  implements bl_fi_generic_doc_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_1_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_1_line: fromDatatype.GuidDataFieldInterface;
  date_doc_1_hdr: fromDatatype.TimestampTzDatatypeInterface;
  date_doc_1_line: fromDatatype.TimestampTzDatatypeInterface;
  guid_doc_2_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_2_line: fromDatatype.GuidDataFieldInterface;
  date_doc_2_hdr: fromDatatype.TimestampTzDatatypeInterface;
  date_doc_2_line: fromDatatype.TimestampTzDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  option: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  quantity_contra: fromDatatype.NumericDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  amount_contra: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  guid_doc_event: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  server_doc_type_doc_1_hdr: fromDatatype.VarcharDatatypeInterface;
  server_doc_type_doc_2_hdr: fromDatatype.VarcharDatatypeInterface;
  server_doc_type_doc_1_line: fromDatatype.VarcharDatatypeInterface;
  server_doc_type_doc_2_line: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_1: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_2: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_3: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_4: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_server_doc_5: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_1: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_2: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_3: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_4: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_client_doc_5: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_reference_no: fromDatatype.JsonDatatypeInterface;
  doc_hdr_1_tracking_no: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_1: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_2: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_3: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_4: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_server_doc_5: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_1: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_2: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_3: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_4: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_client_doc_5: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_reference_no: fromDatatype.JsonDatatypeInterface;
  doc_hdr_2_tracking_no: fromDatatype.JsonDatatypeInterface;
}
